import _toConsumableArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import { Dialog } from '@headlessui/react';
import React, { useCallback, useEffect } from 'react';
import { useSpring, a, animated, easings } from '@react-spring/web';
import { useDrag } from '@use-gesture/react';
import { DragHandleIcon, useIsEmployerApp } from '@restworld/utils-common';
import { Button } from '../../button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function MobileModalWithGestures(_ref) {
  var dragHandleIcon = _ref.dragHandleIcon,
      title = _ref.title,
      children = _ref.children,
      open = _ref.open,
      onClose = _ref.onClose,
      noPadding = _ref.noPadding,
      _ref$showDragHandleIc = _ref.showDragHandleIcon,
      showDragHandleIcon = _ref$showDragHandleIc === void 0 ? true : _ref$showDragHandleIc,
      modalStyles = _ref.modalStyles,
      footer = _ref.footer,
      footerStyles = _ref.footerStyles,
      primaryActionLabel = _ref.primaryActionLabel,
      onClickPrimaryAction = _ref.onClickPrimaryAction,
      secondaryActionLabel = _ref.secondaryActionLabel,
      onClickSecondaryAction = _ref.onClickSecondaryAction,
      padBodyBottom = _ref.padBodyBottom,
      hasHeaderBorderBottom = _ref.hasHeaderBorderBottom,
      headerStyles = _ref.headerStyles,
      _ref$disableDrag = _ref.disableDrag,
      disableDrag = _ref$disableDrag === void 0 ? false : _ref$disableDrag,
      hasOffWhiteBackground = _ref.hasOffWhiteBackground;
  var height = 646;

  var _useSpring = useSpring(function () {
    return {
      y: height
    };
  }),
      _useSpring2 = _slicedToArray(_useSpring, 2),
      y = _useSpring2[0].y,
      api = _useSpring2[1];

  var _useIsEmployerApp = useIsEmployerApp(),
      isEmployerApp = _useIsEmployerApp.isEmployerApp;

  var openModal = useCallback(function (_ref2) {
    var canceled = _ref2.canceled;
    api.start({
      y: 0,
      immediate: true,
      config: {
        easing: canceled ? easings.easeInSine : easings.linear
      }
    });
  }, [api]);
  var closeModal = useCallback(function () {
    var _velocity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : height;
    api.start({
      y: y,
      immediate: false,
      config: {
        easing: easings.easeOutElastic
      }
    });
    onClose();
  }, [api, onClose]);
  useEffect(function () {
    if (open) {
      openModal({
        canceled: false
      });
    }
  }, [open, openModal]);
  var bindGesture = useDrag(function (_ref3) {
    var last = _ref3.last,
        _ref3$velocity = _slicedToArray(_ref3.velocity, 2),
        vy = _ref3$velocity[1],
        _ref3$direction = _slicedToArray(_ref3.direction, 2),
        dy = _ref3$direction[1],
        _ref3$offset = _slicedToArray(_ref3.offset, 2),
        oy = _ref3$offset[1],
        cancel = _ref3.cancel,
        canceled = _ref3.canceled;

    // Determine the threshold for closing the modal (you can adjust this)
    var closeThreshold = height * 0.3; // Apply opacity to the modal

    api.start({
      y: oy,
      immediate: true
    }); // if the user drags up passed a threshold, then we cancel
    // the drag so that the sheet resets to its open position

    if (oy < -closeThreshold) cancel(); // when the user releases the sheet, we check whether it passed
    // the threshold for it to close, or if we reset it to its open position

    if (last) {
      if (oy > closeThreshold || vy > 0.5 && dy > 0) {
        closeModal(vy);
      } else {
        openModal({
          canceled: canceled
        });
      }
    }
  }, {
    from: function from() {
      return [0, y.get()];
    },
    filterTaps: true,
    bounds: {
      top: 0
    },
    rubberband: true
  });
  var display = y.to(function (py) {
    return py <= height ? 'flex' : 'none';
  });
  return /*#__PURE__*/_jsxs(StyledMobileDialogPanel, {
    style: {
      y: y,
      display: display
    },
    $hasOffWhiteBackground: hasOffWhiteBackground || isEmployerApp,
    $noPadding: noPadding,
    children: [/*#__PURE__*/_jsxs(MobileHeaderStyled, _objectSpread(_objectSpread({
      $headerStyles: headerStyles
    }, disableDrag ? {} : bindGesture()), {}, {
      $noPadding: noPadding,
      children: [showDragHandleIcon ? /*#__PURE__*/_jsx(_StyledDiv, {
        children: /*#__PURE__*/_jsx(_StyledButton, {
          children: dragHandleIcon || /*#__PURE__*/_jsx(DragHandleIcon, {})
        })
      }) : null, title && /*#__PURE__*/_jsx("div", {
        className: "flex flex-row w-full justify-center ".concat(hasHeaderBorderBottom ? 'border-b border-neutral-40 pb-2.5' : ''),
        children: typeof title === 'string' ? /*#__PURE__*/_jsx(_StyledH, {
          children: title
        }) : title
      })]
    })), /*#__PURE__*/_jsx(MobileModalBody, {
      noPadding: noPadding,
      modalStyles: modalStyles,
      padBottom: padBodyBottom,
      children: children
    }), (footer || primaryActionLabel || secondaryActionLabel) && /*#__PURE__*/_jsxs(MobileModalFooter, {
      noPadding: noPadding,
      footerStyles: footerStyles,
      children: [footer, (primaryActionLabel || secondaryActionLabel) && /*#__PURE__*/_jsxs(_StyledDiv2, {
        children: [primaryActionLabel && /*#__PURE__*/_jsx(Button, {
          fullwidth: true,
          title: primaryActionLabel,
          variant: "normal",
          onClick: function onClick() {
            if (onClickPrimaryAction) {
              onClickPrimaryAction();
            }
          }
        }), secondaryActionLabel && /*#__PURE__*/_jsx(Button, {
          fullwidth: true,
          title: secondaryActionLabel,
          variant: "secondary-outline",
          onClick: function onClick() {
            if (onClickSecondaryAction) {
              onClickSecondaryAction();
            }
          }
        })]
      })]
    })]
  });
}
var AnimatedDialogPanel = animated(Dialog.Panel);

var StyledMobileDialogPanel = /*#__PURE__*/_styled(AnimatedDialogPanel).withConfig({
  displayName: "mobile-modal-with-gestures__StyledMobileDialogPanel",
  componentId: "sc-xz3g2b-0"
})(function (_ref4) {
  var $hasOffWhiteBackground = _ref4.$hasOffWhiteBackground,
      $noPadding = _ref4.$noPadding;
  return [{
    "boxSizing": "border-box",
    "display": "flex",
    "minHeight": "75dvh",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "flex-start",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(250 250 250 / var(--tw-bg-opacity))"
  }, {
    "height": "fit-content",
    "maxHeight": "90dvh",
    "minWidth": "100%",
    "maxWidth": "100vw",
    "touchAction": "none",
    "borderTopLeftRadius": "1.563rem",
    "borderTopRightRadius": "1.563rem"
  }, $hasOffWhiteBackground ? {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(250 250 250 / var(--tw-bg-opacity))"
  } : {}, $noPadding ? {
    "paddingBottom": "0px"
  } : {}];
});

var MobileHeaderStyled = /*#__PURE__*/_styled(a.div).withConfig({
  displayName: "mobile-modal-with-gestures__MobileHeaderStyled",
  componentId: "sc-xz3g2b-1"
})(function (_ref5) {
  var $headerStyles = _ref5.$headerStyles,
      $noPadding = _ref5.$noPadding;
  return [{
    "display": "flex",
    "width": "100%",
    "touchAction": "none",
    "flexDirection": "column",
    "alignItems": "flex-start",
    "justifyContent": "flex-start",
    "gap": "0.5rem",
    "paddingBottom": "1rem"
  }].concat(_toConsumableArray($headerStyles || []), [$noPadding ? {
    "paddingBottom": "0px"
  } : {}]);
});

var MobileModalBody = /*#__PURE__*/_styled.div.withConfig({
  displayName: "mobile-modal-with-gestures__MobileModalBody",
  componentId: "sc-xz3g2b-2"
})(function (_ref6) {
  var noPadding = _ref6.noPadding,
      modalStyles = _ref6.modalStyles,
      padBottom = _ref6.padBottom;
  return [{
    "boxSizing": "border-box",
    "display": "flex",
    "width": "100%",
    "maxWidth": "100vw",
    "flex": "1 1 0%",
    "flexGrow": "1",
    "flexDirection": "column",
    "alignItems": "flex-start",
    "overflowY": "auto"
  }, {
    "paddingLeft": "1.5rem",
    "paddingRight": "1.5rem"
  }, noPadding && {
    "paddingLeft": "0px",
    "paddingRight": "0px"
  }, padBottom && {
    "marginBottom": "4rem"
  }].concat(_toConsumableArray(modalStyles || []));
});

var MobileModalFooter = /*#__PURE__*/_styled.div.withConfig({
  displayName: "mobile-modal-with-gestures__MobileModalFooter",
  componentId: "sc-xz3g2b-3"
})(function (_ref7) {
  var noPadding = _ref7.noPadding,
      footerStyles = _ref7.footerStyles;
  return [{
    "boxSizing": "border-box",
    "display": "flex",
    "width": "100%",
    "flexDirection": "column",
    "alignItems": "flex-start",
    "alignSelf": "flex-end",
    "borderTopWidth": "1px",
    "--tw-border-opacity": "1",
    "borderColor": "rgb(222 222 225 / var(--tw-border-opacity))",
    "paddingTop": "1rem",
    "paddingBottom": "1rem",
    "paddingLeft": "1.5rem",
    "paddingRight": "1.5rem"
  }, noPadding ? {
    "paddingLeft": "0px !important",
    "paddingRight": "0px !important",
    "paddingTop": "0px !important",
    "paddingBottom": "0px !important"
  } : {}].concat(_toConsumableArray(footerStyles || []));
});

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "mobile-modal-with-gestures___StyledDiv",
  componentId: "sc-xz3g2b-4"
})({
  "boxSizing": "border-box",
  "display": "flex",
  "width": "100%",
  "flexDirection": "row",
  "justifyContent": "center",
  "paddingTop": "1.5rem",
  "paddingBottom": "1.5rem",
  "paddingLeft": "1rem",
  "paddingRight": "1rem"
});

var _StyledButton = /*#__PURE__*/_styled("button").withConfig({
  displayName: "mobile-modal-with-gestures___StyledButton",
  componentId: "sc-xz3g2b-5"
})({
  "borderStyle": "none",
  "outline": "2px solid transparent",
  "outlineOffset": "2px"
});

var _StyledH = /*#__PURE__*/_styled("h3").withConfig({
  displayName: "mobile-modal-with-gestures___StyledH",
  componentId: "sc-xz3g2b-6"
})({
  "textAlign": "center",
  "fontSize": "1.25rem",
  "lineHeight": "1.5rem",
  "fontWeight": "600",
  "--tw-text-opacity": "1",
  "color": "rgb(17 24 39 / var(--tw-text-opacity))"
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "mobile-modal-with-gestures___StyledDiv2",
  componentId: "sc-xz3g2b-7"
})({
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "alignItems": "flex-start",
  "gap": "1rem"
});